import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { MdKeyboardBackspace as BackIcon } from "react-icons/md";

import Viewer from "../UI/Viewer";
import ContentWrapper from "../UI/ContentWrapper";
import AppBar, { AppBarContentWrapper } from "../AppBar/AppBar";
import withTracker from "../../utils/withTracker";

class SiteInfo extends Component {
  static propTypes = {
    history: PropTypes.shape({
      action: PropTypes.func.isRequired,
      goBack: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired
    }).isRequired
  };

  handleBackButton = () => {
    if (this.props.history.action === "PUSH") {
      this.props.history.goBack();
    } else {
      this.props.history.push("/");
    }
  };

  render() {
    return (
      <Viewer>
        <AppBar showBackButton>
          <AppBarContentWrapper>
            <BackIcon size={24} onClick={this.handleBackButton} />
          </AppBarContentWrapper>
        </AppBar>
        <ContentWrapper>
          <div
            dangerouslySetInnerHTML={{ __html: this.props.site.description }}
          />
        </ContentWrapper>
      </Viewer>
    );
  }
}
SiteInfo.propTypes = {
  site: PropTypes.shape({
    description: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(withTracker(SiteInfo));
